import { Box, Skeleton, Grid } from '@mui/joy'
import { useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { Switch } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'
import { $carEquipments, requestCarEquipmentsFx } from '../model'

type EquipmentsProps = {
  loading: boolean
}

export function Equipments({ loading }: EquipmentsProps) {
  const { t } = useTranslation()
  const isCarEquipmentsLoading = useStore(requestCarEquipmentsFx.pending)
  const carEquipments = useStore($carEquipments)

  if (!carEquipments)
    return <Box color='error'>{t('form.completeness error')}</Box>

  return (
    <Container>
      <ContainerTitle>{t('form.completeness')}</ContainerTitle>
      <Grid container spacing={5}>
        {isCarEquipmentsLoading ? (
          <Skeleton
            sx={{
              height: '342px',
              position: 'relative',
              borderRadius: '8px',
              margin: '0 24px 24px',
            }}
          />
        ) : (
          carEquipments.map((param) => (
            <Grid xs={4} key={param.id}>
              <Switch
                label={param.label}
                name={`equipments.${param.id}`}
                readOnly
                skeletonShow={loading}
              />
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  )
}
